// @flow
import logger from 'portfolio-shared/util/logging';
import { getIdentitySession, getLocale, getPorts } from 'state/selectors';
import type { Dispatch, ReportData, GetState } from 'state/types';
import { API } from 'util/constants';
import { localeToReportLocale } from 'util/reportUtils';
import { getAdminAddress, getMainServerPort } from 'util/serverUtils';

function getURLFragmentForReportName(reportName) {
  if (reportName === 'keyword-statistics') {
    return '&fieldName=Keywords&maxRows=0';
  }
  return '';
}

function getUrl(base: string, reportData: ReportData, getState: GetState) {
  const session = getIdentitySession(getState());
  if (!session) {
    logger.error("Can't run report, no identity session");
    return;
  }
  const locale = localeToReportLocale(getLocale(getState()));
  const ports = getPorts(getState());
  const serverAddress = getAdminAddress(ports);

  const dateFragment =
    reportData.startingDate && reportData.endingDate
      ? `&startingDate=${reportData.startingDate}&endingDate=${
          reportData.endingDate
        }`
      : '';
  const catalogIdFragment = reportData.catalogId
    ? `&catalog_id=${reportData.catalogId}`
    : '';
  const catalogNameFragment = reportData.catalogName
    ? `&catalogName=${reportData.catalogName}`
    : '';
  const siteIdFragment = reportData.siteId
    ? `&site_id=${reportData.siteId}`
    : '';
  const reportSpecificFragment = getURLFragmentForReportName(reportData.name);
  const includeHeader = (!!reportData.isDownload).toString();

  return (
    serverAddress +
    base +
    `&session=${session}` +
    `&locale=${locale}` +
    `&includeHeader=${includeHeader}` +
    reportSpecificFragment +
    catalogNameFragment +
    catalogIdFragment +
    siteIdFragment +
    dateFragment
  );
}

export function downloadReport(reportData: ReportData) {
  return async function downloadReport(dispatch: Dispatch, getState: GetState) {
    const base = `${API}/report/${reportData.name}?`;
    const url = getUrl(base, reportData, getState);
    window.location = url;
  };
}

export function viewReport(reportData: ReportData) {
  return async function viewReport(dispatch: Dispatch, getState: GetState) {
    const ports = getPorts(getState());
    const port = getMainServerPort(ports);
    const base =
      `/reporting/rdPage.aspx?` +
      `rdReport=${reportData.viewName}` +
      `&port=${port}`;

    const url = getUrl(base, reportData, getState);
    window.open(url, '_blank');
  };
}



// WEBPACK FOOTER //
// ./src/state/commands/reportCommands.js